import React from 'react';
import { Message } from '../Message';
import { PageTitle } from '../PageTitle';
import { ScrollModule } from '../ScrollModule';
import ScrollArea from 'react-scrollbar';
import QuickLinkList from './quick_link_list';

class QuickLinks extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            localErrorMessage: null
        };
    }

    messageDismissCallback() {
        this.setState({ localErrorMessage: null });
    }

    renderMessages() {
        if (this.state.localErrorMessage) {
            return (
                <Message errorMessage={this.state.localErrorMessage} messageDismissCallback={this.messageDismissCallback.bind(this)} />
            );
        }

        if (this.props.location.state) {
            return <Message messages={this.props.location} />;
        }
        return null;
    }

    handleLocalError(localErrorMessage) {
        this.setState({ localErrorMessage });
    }

    render() {
        return (
            <div className="animated fadeIn">
                <div className="row">
                    <PageTitle
                        title="Configure Quick Links"
                        addLinkWithParams={{
                            link: { pathname: '/admin-admin/quick-links/add' },
                            state: { backLinkSearch: this.props.location.search }
                        }}
                    />
                </div>
                {this.renderMessages()}
                <div className="op-content-box">
                    <ScrollModule />
                    <ScrollArea
                        speed={0.8}
                        className="scroll-container"
                        contentClassName="scrollable-content"
                        horizontal={true}
                    >
                        <div className="row">
                            <div className="col-sm-12">
                                <div className="card">
                                    <div className="card-block">
                                        <QuickLinkList
                                            localErrorHandler={this.handleLocalError.bind(this)}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ScrollArea>
                </div>
            </div>
        );
    }
}

export default QuickLinks;
